import { useLayoutEffect, useState } from "react";
import { X1DarkModeSetting } from "@x1-theme/X1DarkModeSetting";
import { executionEnvironment } from "@x1-utils/ExecutionEnvironment";

const DARK_MODE_MEDIA_QUERY = "(prefers-color-scheme: dark)";
const listeners = new Set();

function getSystemPrefersDarkMode(getPreference) {
  if (!executionEnvironment.canUseDOM) {
    const preference = getPreference();
    return (
      preference === "ENABLED" ||
      (preference === "USE_SYSTEM" &&
        X1DarkModeSetting.initialGuessForDarkModeOnClient)
    );
  }
  return window.matchMedia && window.matchMedia(DARK_MODE_MEDIA_QUERY).matches;
}

function useSystemPrefersDarkMode(getPreference) {
  let [prefersDarkMode, setPrefersDarkMode] = useState(() => {
    return getSystemPrefersDarkMode(getPreference);
  });

  useLayoutEffect(() => {
    let listener = function (event) {
      setPrefersDarkMode(event.matches);
    };
    listeners.add(listener);
    return () => {
      listeners["delete"](listener);
    };
  }, []);

  return prefersDarkMode;
}

export const UseSystemPrefersDarkMode = {
  useSystemPrefersDarkMode,
};
